import classNames from "classnames";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../../redux/hooks";
import { Button } from "../../../buttons/button";

export const CreateEventButton = () => {
  const [collapseButton, setCollapseButton] = useState(false);

  const navigate = useNavigate();

  const { hasCreatedEvent } = useAppSelector((state) => state.auth);

  useEffect(() => {
    const myTimeout = setTimeout(() => {
      setCollapseButton(true);
    }, 1500);

    return () => {
      if (myTimeout) {
        clearTimeout(myTimeout);
      }
    };
  });

  return (
    <Button
      text={collapseButton ? "" : "Create Event"}
      icon="plus"
      type="button"
      className={classNames(
        {
          "!w-[168px]": !collapseButton,
          "!size-[50px] overflow-hidden !p-0": collapseButton,
        },
        "transition-all duration-[800ms]",
      )}
      onClick={() => {
        if (hasCreatedEvent) {
          navigate("/event/new", { replace: true });
        } else {
          navigate("/complete-profile");
        }
      }}
      iconDimension={collapseButton ? 20 : 16}
    />
  );
};
